import { render } from "./CustomInput.vue?vue&type=template&id=48cb59b7&scoped=true"
import script from "./CustomInput.vue?vue&type=script&lang=js"
export * from "./CustomInput.vue?vue&type=script&lang=js"

import "./CustomInput.vue?vue&type=style&index=0&id=48cb59b7&scoped=true&lang=css"

import exportComponent from "/home/jocelino/IGAMES-PS2/panel/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48cb59b7"]])

export default __exports__